<section class="page-section" id="jobs">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <h2 class="section-heading text-uppercase">Jobs</h2>
              <h3 class="section-subheading">We have the following jobs available</h3>
            </div>
          </div>
          <form class="search-form " (submit)="search()">
            <div class="row extra-background">
              <div class="col-md-5">
                  <mat-form-field appearance="outline">
                      <mat-label>keyword</mat-label>
                      <input matInput  placeholder="keyword" [formControl]="searchForm.controls.keyword">
                      <mat-hint>Job title or company</mat-hint>
                  </mat-form-field>
              </div>
              <div class="col-md-5">
                  <mat-form-field appearance="outline">
                      <mat-label>Location</mat-label>
                      <input matInput [matAutocomplete]="autoLocation" placeholder="location" [formControl]="searchForm.controls.location">
                      <mat-hint>City, Town or Province</mat-hint>
                  </mat-form-field>
                  <mat-autocomplete #autoLocation="matAutocomplete" [displayWith]="showName">
                    <mat-option color="primary" *ngFor="let location of filterLocations()" [value]="location">{{location.name}} <span *ngIf="location.parent > 0" >{{getParent(location.parent)}}</span></mat-option>
                  </mat-autocomplete>
              </div>
              <div class="col-md-2">
                  <button class="btn btn-fsp btn-search" mat-button><mat-icon matButtonIcon>search</mat-icon></button>
              </div>
          </div>
          </form>
          <div class='form-result-header'>
            <h4>Job list</h4>
          </div>
          <hr/>
          <div class=" form-results-content">
              <mat-card class="example-card" *ngFor="let job of filteredJobs">
                <mat-card-header>
                  <mat-card-title>{{job.title}}</mat-card-title>
                  <mat-card-subtitle>{{displaySalary(job.salary)}}</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <p class="text-justify">
                    {{job.description.length <= 200?job.description:job.description.substring(0,200) + ' ....'}}
                  </p>
                </mat-card-content>
                <mat-card-actions>
                  <button mat-ripple class="btn btn-fsp" [routerLink]="'/jobs/'+job.id" >view</button>
                  <!-- <button mat-icon-button color="warn"><mat-icon>favorite</mat-icon></button> -->
                </mat-card-actions>
              </mat-card>
            </div>
          <div class='form-result-footer'>
            <mat-paginator [length]='filteredJobs.length' [pageSize]='10'></mat-paginator>
          </div>
    </div>
  </section>
